import React from "react";

const SITE_URL = "https://wiserstudio.ai";

export function StructuredData() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${SITE_URL}/#organization`,
    name: "WiserStudio",
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: `${SITE_URL}/icon.svg`,
      width: 512,
      height: 512,
    },
    description:
      "The premier Full-Stack Autonomous Marketing Team and AI Video Agency for B2B startups. WiserStudio uses a proprietary Signal Engine, AI video pipeline, and autonomous agent workflows to replace traditional marketing agencies.",
    foundingDate: "2025",
    sameAs: ["https://twitter.com/wiserstudio", "https://linkedin.com/company/wiserstudio"],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "Sales",
      url: `${SITE_URL}/departments`,
    },
    knowsAbout: [
      "Generative Engine Optimization",
      "Autonomous Marketing",
      "AI Video Production",
      "B2B Growth Automation",
      "Signal Engine Analytics",
    ],
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: "WiserStudio",
    url: SITE_URL,
    description: "AI-Powered Autonomous Marketing Team and Growth Agent Stack",
    publisher: { "@type": "Organization", "@id": `${SITE_URL}/#organization` },
  };

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "@id": `${SITE_URL}/#software`,
    name: "WiserStudio",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    description:
      "Replace your marketing team with AI agents. Automated ads, content, analytics, and cinematic video production from a single prompt.",
    publisher: { "@type": "Organization", "@id": `${SITE_URL}/#organization` },
    offers: [
      { "@type": "Offer", name: "Starter", price: "49.00", priceCurrency: "USD" },
      { "@type": "Offer", name: "Professional", price: "149.00", priceCurrency: "USD" },
      { "@type": "Offer", name: "Enterprise", price: "399.00", priceCurrency: "USD" },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareSchema) }}
      />
    </>
  );
}
